/**
 * Vuex-модуль (хранилище) для работы модального окна подтверждения пароля
 */

const state = {
    // Состояние отображения модального окна
    isShown: false,
    // База
    base: null,
};

const actions = {
    // Отображение модального окна
    showBaseInviteAcceptModal: ({ commit }, base) => commit('showBaseInviteAcceptModal', base),
    // Скрытие модального окна
    hideBaseInviteAcceptModal: ({ commit }) => commit('hideBaseInviteAcceptModal'),
};

const mutations = {
    showBaseInviteAcceptModal: (state, base) => {
        state.isShown = true;
        state.base = base;
    },
    hideBaseInviteAcceptModal: state => {
        state.isShown = false;
        state.base = null;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
